import { render, staticRenderFns } from "./newGovernmentMember.vue?vue&type=template&id=5f8c0f2a&scoped=true&"
import script from "./newGovernmentMember.vue?vue&type=script&lang=js&"
export * from "./newGovernmentMember.vue?vue&type=script&lang=js&"
import style0 from "./newGovernmentMember.vue?vue&type=style&index=0&id=5f8c0f2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c0f2a",
  null
  
)

export default component.exports